export default [
  {
    path: '/visit-locations',
    name: 'visit-locations',
    meta: {
      protected: true,
      pageTitle: 'Visit Locations',
    },
    component: () => import('@/views/visitLocations/VisitLocations.vue'),
  },
]
